import * as React from 'react';

const ChevronDown24: React.FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
		<path
			d='M18 10L12.2827 15.8795C12.2456 15.9177 12.2015 15.948 12.153 15.9687C12.1045 15.9894 12.0525 16 12 16C11.9475 16 11.8955 15.9894 11.847 15.9687C11.7985 15.948 11.7544 15.9177 11.7173 15.8795L6 10'
			stroke='currentColor'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export default ChevronDown24;
